import React from 'react'

import { RequestContext } from 'src/lib/js/context'
import { PageShellInfrastructure } from './page_shell/PageShellInfrastructure'

type Props = {
  titleTag?: string
  descriptionTag?: string
  staticContext?: RequestContext
}

/**
 * EcommercePageShell provides PageShell infrastructure (meta, tracking, structure)
 * WITHOUT providing contexts (those are provided by EcommerceProvidersWrapper).
 *
 * This is used for ecommerce routes to avoid duplicate providers while maintaining
 * all the PageShell functionality.
 */
export const EcommercePageShell = ({
  titleTag,
  descriptionTag,
  staticContext,
  children
}: React.PropsWithChildren<Props>) => {
  return (
    <PageShellInfrastructure
      titleTag={titleTag}
      descriptionTag={descriptionTag}
      staticContext={staticContext}
      noPopups
    >
      {children}
    </PageShellInfrastructure>
  )
}
